import { NgModule, ErrorHandler } from '@angular/core';
import { IonicModule, IonicErrorHandler } from 'ionic-angular';
import { PageRef } from '../../core/core.module';

import { IonImgCache } from '../ionic2-img-cache/ion-img-cache';

import { RecipePage } from './pages/recipe/recipe';
import { RecipePageFull } from './pages/recipe/recipe.full';
import { RecipeCommon } from './pages/recipe/recipe.common';
import { RecipeDetailPage } from './pages/recipe-detail/recipe-detail';
import { RecipeDetailPageFull } from './pages/recipe-detail/recipe-detail.full';
import { RecipeDetailCommon } from './pages/recipe-detail/recipe-detail.common';
import { RecipeListPage } from './pages/recipe-list/recipe-list';
import { RecipeListPageFull } from './pages/recipe-list/recipe-list.full';
import { RecipeListCommon } from './pages/recipe-list/recipe-list.common';
import { RecipeBoxesPage } from './pages/recipe-boxes/recipe-boxes';
import { RecipeBoxesPageFull } from './pages/recipe-boxes/recipe-boxes.full';
import { RecipeBoxesCommon } from './pages/recipe-boxes/recipe-boxes.common';
import { CategoryBoxesPage } from './pages/category-boxes/category-boxes';
import { CategoryBoxesPageFull } from './pages/category-boxes/category-boxes.full';
import { CategoryBoxesCommon } from './pages/category-boxes/category-boxes.common';

import { RecipeData } from './providers/recipe-data';
import { LocalRecipeBoxData } from './providers/local-recipe-box-data';
import { UserRecipeBoxData } from './providers/user-recipe-box-data';
import { GuestRecipeBoxData } from './providers/guest-recipe-box-data';
import { RecipeBoxDataGateway } from './providers/recipe-box-data-gateway';
import { ShareButtonsModule } from "ng2-sharebuttons";

import { UserShoppingItemsData } from '../account/providers/user-shopping-items-data';
import { LocalShoppingItemsData } from '../account/providers/local-shopping-items-data';
import { GuestShoppingItemsData } from '../account/providers/guest-shopping-items-data';
import { ShoppingItemsDataGateway } from '../account/providers/shopping-items-data-gateway';


//Export
export { RecipePage } from './pages/recipe/recipe';
export { RecipePageFull } from './pages/recipe/recipe.full';
export { RecipeListPage } from './pages/recipe-list/recipe-list';
export { RecipeDetailPage } from './pages/recipe-detail/recipe-detail';
export { RecipeBoxesPage } from './pages/recipe-boxes/recipe-boxes';
export { CategoryBoxesPage } from './pages/category-boxes/category-boxes';
@NgModule({
    imports: [
        IonicModule,
        ShareButtonsModule,
        IonImgCache
    ],
    declarations: [
        RecipePage,
        RecipePageFull,
        RecipeDetailPage,
        RecipeDetailPageFull,
        RecipeListPage,
        RecipeListPageFull,
        RecipeBoxesPage,
        RecipeBoxesPageFull,
        CategoryBoxesPage,
        CategoryBoxesPageFull
    ],
    exports: [
        RecipePage,
        RecipePageFull,
        RecipeDetailPage,
        RecipeDetailPageFull,
        RecipeListPage,
        RecipeListPageFull,
        RecipeBoxesPage,
        RecipeBoxesPageFull,
        CategoryBoxesPage,
        CategoryBoxesPageFull
    ],
    bootstrap: [],
    entryComponents: [
        RecipePage,
        RecipePageFull,
        RecipeDetailPage,
        RecipeDetailPageFull,
        RecipeListPage,
        RecipeListPageFull,
        RecipeBoxesPage,
        RecipeBoxesPageFull,
        CategoryBoxesPage,
        CategoryBoxesPageFull
    ],
    providers: [{ provide: ErrorHandler, useClass: IonicErrorHandler }, RecipeData, LocalRecipeBoxData, UserRecipeBoxData, GuestRecipeBoxData, RecipeBoxDataGateway, RecipeCommon, RecipeDetailCommon, RecipeListCommon, RecipeBoxesCommon, CategoryBoxesCommon, UserShoppingItemsData, LocalShoppingItemsData, GuestShoppingItemsData, ShoppingItemsDataGateway]
})
export class RecipesModule {
    constructor(public pageRef: PageRef) {
        this.pageRef.addCfgLinks([
            { component: RecipePage, name: 'RecipePage', segment: 'recipes' },
            { component: RecipePage, fullComponent: RecipePageFull, name: 'RecipePage', segment: 'recipes/:categoryUrlSlug' },
            // { component: RecipeListPage, name: 'RecipeListPage', segment: 'recipe-list' },
            { component: RecipeListPage, fullComponent: RecipeListPageFull, name: 'RecipeListPage', segment: 'recipe-list/:categoryUrlSlug' },
            { component: RecipeDetailPage, fullComponent: RecipeDetailPageFull, name: 'RecipeDetailPage', segment: 'recipe-detail/:categoryUrlSlug/:id' },
            { component: RecipeBoxesPage, fullComponent: RecipeBoxesPageFull, name: 'RecipeBoxesPage', segment: 'recipe-boxes/:categoryUrlSlug' },
            { component: RecipeBoxesPage, name: 'RecipeBoxesPage', segment: 'recipe-boxes' },
            { component: CategoryBoxesPage, name: 'CategoryBoxPage', segment: 'category-box' },
        ])
    }
}


// WEBPACK FOOTER //
// ./src/modules/recipes/recipes.module.ts